<ng-container *ngIf="licencesData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="licencesData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--smallMargin">
    <h2 class="Bands">Licences</h2>
  </div>
  <div class="EntryPoint">
    <div class="EntryPoint-header">
      <div class="EntryPoint-country">
        <h3>Country</h3>
      </div>
      <div class="EntryPoint-content">
        <div class="EntryPoint-Bands">
          <div *ngFor="let allBandGroup of licencesData.allBandGroups" class="EntryPoint-Band EntryPoint-Band--{{allBandGroup}}">
            <h3><a [routerLink]="['/licences/bandGroup/'+allBandGroup]" [queryParams]="{regionCode: regionCodes}">{{ ('GroupOfBands.' + allBandGroup) | translate }}</a></h3>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let row of licencesData.licences;" class="EntryPoint-row">
      <div class="EntryPoint-country" [class.EntryPoint-country--active]="isActiveRow(row)" (click)="toggleActiveRows(row)">
        <h2><a [routerLink]="'/licences/country/'+row.countryCode" [queryParams]="{regionCode: regionCodes}">{{ ('CountryNames.' + row.countryCode) | translate }}</a></h2>
      </div>
      <div class="EntryPoint-content">
        <div class="EntryPoint-Bands">
          <div *ngFor="let bandGroup of licencesData.allBandGroups" class="EntryPoint-Band EntryPoint-Band--{{bandGroup}}" [class.EntryPoint-Band--empty]="isBandGroupEmpty(row,bandGroup)">
            <header>
              <h3><a [routerLink]="'/licences/bandGroup/'+bandGroup" [queryParams]="{regionCode: regionCodes}">{{ ('GroupOfBands.' + bandGroup) | translate }}</a></h3>
            </header>
            <ul>
              <li *ngFor="let band of row.bandGroups[bandGroup]">
                <ng-template #tipContent>
                  <span *ngIf="band.ratio > 0">
                    {{ band.ratio }}% awarded
                  </span>
                  <span *ngIf="band.ratio==0">
                    <ng-container *ngIf="band.nationalRegionalCount.local">
                      Local licences
                    </ng-container>
                    <ng-container *ngIf="band.nationalRegionalCount.regional">
                      Regional licences
                    </ng-container>
                    <ng-container *ngIf="band.nationalRegionalCount.regional && band.nationalRegionalCount.local">
                      Regional/Local licences
                    </ng-container>
                  </span>
                </ng-template>
                <a [routerLink]="'/licences/country/'+row.countryCode+'/band/'+band.code" [queryParams]="{regionCode: regionCodes}" class="Band Band--{{band.code}}" [ngbTooltip]="tipContent" [class.Band--empty]="band.ratio === 0">
                  <div class="Band-container">
                    <p>{{ ('Band.' + band.code) | translate }}</p>
                    <span class="Progress" [style.width]="band.ratio+'%'"></span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
